import axios from "axios";

export default {
    state: () => ({
        formList : null,
        form : null,
    }),
    mutations: {
        setFormList:function (state,formList){
            state.formList = formList;
        },
        setForm:function (state,form){
            state.form = form
        },
    },
    getters: {
        getFormList : state => {
            return state.formList
        },
        getForm : state => {
            return state.form
        },
    },
    actions:{
        loadFormList(context){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(context.getters.getServiceUrl + "/admin-api/booking/assistance/forms", {headers})
                .then((response) => {
                    context.commit("setFormList", response.data);
                    return response.data;
                })
        },
        claimForm(context, form){
            let request = {
                bookingAssistanceId : form.id
            }

            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.post(context.getters.getServiceUrl + "/admin-api/booking/assistance/claim", request,{headers})
                .then((response) => {
                    form.claimDate = new Date();
                    context.commit("setForm", response.data);
                    return response.data;
                })
        },
        resolveForm(context, form){
            let request = {
                content : form.responseContent,
                bookingAssistanceId : form.id
            }
            return axios.post(context.getters.getServiceUrl + "/admin-api/booking/assistance/resolve", request,{headers})
                .then((response) => {
                    form.resolveDate = new Date();
                    this.commit("setForm",form);
                    return response.data;
                })
        },
    }
}

